import type { ServiceCardItem } from "@components/ServiceCardItem.js";
import car from "@core/assets/icons/car.svg?raw";
import cloudCircle from "@core/assets/icons/cloud-circle.svg?raw";
import deliverySpeed from "@core/assets/icons/delivery-speed.svg?raw";
import factory from "@core/assets/icons/factory.svg?raw";
import gastro from "@core/assets/icons/gastro.svg?raw";
import hr from "@core/assets/icons/hr.svg?raw";
import retail from "@core/assets/icons/retail.svg?raw";
import shoppingCart from "@core/assets/icons/shopping-cart.svg?raw";
import stavebnictvi from "@core/assets/icons/stavebnictvi.svg?raw";
import ucetnictvi from "@core/assets/icons/ucetnictvi.svg?raw";
import type { Tenant } from "@core/schema/Tenant.js";
import { getAccountingPath } from "@core/schema/paths/getAccountingPath.js";
import { getEcommercePath } from "@core/schema/paths/getEcommercePath.js";
import { getGastroPath } from "@core/schema/paths/getGastroPath.js";
import { getHRPath } from "@core/schema/paths/getHRPath.js";
import { getProductionPath } from "@core/schema/paths/getProductionPath.js";
import { getTransportPath } from "@core/schema/paths/getTransportPath.js";

export function getIndustries(tenant: Tenant): ServiceCardItem<true>[] {
	return [
		{
			title: "E-commerce",
			iconName: shoppingCart,
			href: getEcommercePath(tenant),
			show: true,
		},

		{
			title: "Gastronomie a hotely",
			iconName: gastro,
			href: getGastroPath(tenant),
			show: true,
		},
		{
			title: "Přeprava",
			iconName: deliverySpeed,
			href: getTransportPath(tenant),
			show: true,
		},
		{
			title: "XaaS",
			iconName: cloudCircle,
			href: "/#",
			show: false,
		},
		{
			title: "Výroba",
			iconName: factory,
			href: getProductionPath(tenant),
			show: true,
		},
		{
			title: "HR",
			iconName: hr,
			href: getHRPath(tenant),
			show: true,
		},
		{
			title: "Účetnictví",
			iconName: ucetnictvi,
			href: getAccountingPath(tenant),
			show: true,
		},
		{
			title: "Automotive",
			iconName: car,
			href: "/#",
			show: false,
		},
		{
			title: "Stavebnictví",
			iconName: stavebnictvi,
			href: "/#",
			show: false,
		},
		{
			title: "Retail",
			iconName: retail,
			href: "/#",
			show: false,
		},
	];
}
